import React from 'react';

const DefaultCardStatsIcon = () => {
  return (
    <svg
      width='96'
      height='32'
      viewBox='0 0 96 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='96' height='32' rx='12' fill='white' fillOpacity='0.6' />
      <path
        d='M64 12L68 16M68 16L64 20M68 16H48'
        stroke='#9CA3AF'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M74.96 15.464V14.456H81.68V15.464H74.96ZM83.7606 15.464V14.456H90.4806V15.464H83.7606Z'
        fill='#9CA3AF'
      />
    </svg>
  );
};

export default DefaultCardStatsIcon;
